import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Logger } from '../utils/Logger';
import { LenderApplicationStatus } from "../model/lender.model";
import { UserAttributeService } from "../service/finzy-flex/user/user-attribute.service";
import { Keys, StorageService } from "../service/storage.service";
import { FfEndPoints } from "../views/investors/finzy-flex/ff-endpoints";

@Injectable()
export class FinzyFlexGuard implements CanActivate {
    private router: Router;
    private storageService: StorageService;
    private userAttributeService: UserAttributeService;

    constructor(
        router: Router,
        storageService: StorageService,
        userAttributeService: UserAttributeService,
    ) {
        this.router = router;
        this.storageService = storageService;
        this.userAttributeService = userAttributeService;
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        const lenderId: string = this.storageService.getItem(Keys.LENDER_ID);
        const lenderBasicInfo = await this.userAttributeService.getLenderBasicInfo(lenderId);
        if (lenderBasicInfo.lenderApplicationStatus === LenderApplicationStatus.VERIFIED || lenderBasicInfo.lenderApplicationStatus === LenderApplicationStatus.INVESTED) {
            return true;
        } 
        else if(lenderBasicInfo.lenderApplicationStatus === LenderApplicationStatus.PENDING && state.url.substring(1) === FfEndPoints.PREFERENCES) {
            return this.router.createUrlTree(['invest/investment-preferences']);
        }
        else {
            Logger.log(`User is not allowed to view flex dashboard.  Navigating to lender kyc page.`);
            return this.router.createUrlTree([FfEndPoints.INVESTMENT_INITIAL]);
        }
    }
}